'use client';

import React from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { LoggingView } from '@/utils/logger';
import { usePageInfo } from '@skin-seoul/utils';
import { useReportWebVitals, useNavigationProgress } from '../hooks';
import { PageTransitionLoader } from '@/components/ui/PageTransitionLoader';
interface LayoutClientProps {
  children: React.ReactNode;
}
function LayoutClient({
  children
}: LayoutClientProps) {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const {
    title
  } = usePageInfo(pathname);
  const {
    isNavigating
  } = useNavigationProgress();
  useReportWebVitals();
  const url = pathname + (searchParams.toString() ? `?${searchParams.toString()}` : '');
  return <>
      <PageTransitionLoader isLoading={isNavigating} data-sentry-element="PageTransitionLoader" data-sentry-source-file="layout.client.tsx" />
      <LoggingView params={{
      page_location: url,
      page_path: pathname,
      page_title: title
    }} data-sentry-element="LoggingView" data-sentry-source-file="layout.client.tsx">{children}</LoggingView>
    </>;
}
export default LayoutClient;